import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from 'react-awesome-modal';
import _ from 'lodash';

import Button from '../../../shared/button/components/button';
import CloseBtn from '../../../shared/close-btn/components/close-btn';
import { toggleExportTableModal } from '../actions/clients-actions';
import clientsConstant from '../constants/clients-constants';

class ExportTableModal extends Component {
  closeModal() {
    const { toggleExportTableModal } = this.props;

    toggleExportTableModal(false);
  }

  renderExportButtons(buttons) {
    const { exportCallback, isOnlineAffiliate, httpInProgress } = this.props;

    if (buttons && buttons.length > 0) {
      return buttons.map((button, index) => {
        return (
          <div className="col-sm-12" key={index}>
            <Button label={button.label} customClass={`m-t-20`} icon={button.icon} disabled={httpInProgress} onClick={() => exportCallback(isOnlineAffiliate, button.type)} />
          </div>
        );
      });
    }
  }

  render() {
    const { showExportTableModal } = this.props;
    const exportButtons = _.values(clientsConstant.export_buttons);

    return (
      <Modal visible={showExportTableModal} effect="fadeInUp" onClickAway={() => this.closeModal()}>
        <div className="banner-code-modal">
          <CloseBtn callback={this.closeModal.bind(this)} />
          <div className="row">{this.renderExportButtons(exportButtons)}</div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  showExportTableModal: state.clientsReducer.showExportTableModal,
  httpInProgress: state.httpInProgressReducer.httpInProgress,
});

const mapDispatchToProps = dispatch => ({
  toggleExportTableModal: show => {
    dispatch(toggleExportTableModal(show));
  },
});

ExportTableModal.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ExportTableModal);



// WEBPACK FOOTER //
// ./src/app/main/clients/components/export-table-modal.js